import React from 'react';
import { Pipette } from 'lucide-react';
import { useLang } from './i18n';

// Discord-style profile theme picker: one gradient tile with a handle for the top and the bottom colour.
const PRESETS: [string, string][] = [
  ['#ef5252', '#3a0d14'], ['#00b4d8', '#03045e'], ['#8b5cf6', '#1e1037'], ['#10b981', '#052e22'], ['#f59e0b', '#3b1d04'],
  ['#ec4899', '#3b0a24'], ['#5865f2', '#0f1240'], ['#f97316', '#7c2d12'], ['#a3e635', '#14532d'], ['#e2e8f0', '#334155'],
];
// Keep this component identity stable while the native colour dialog emits input events.
function Handle({ pos, value, set }: { pos: 'top' | 'bottom'; value: string; set: (v: string) => void }) {
  const [, , tr] = useLang();
  return (
    <label className={'gp-handle gp-' + pos} style={{ background: value }} title={pos === 'top' ? tr('Top colour', 'Obere Farbe') : tr('Bottom colour', 'Untere Farbe')}>
      <Pipette size={12} />
      <input type="color" value={value} onChange={e => set(e.target.value)} aria-label={pos === 'top' ? tr('Top colour', 'Obere Farbe') : tr('Bottom colour', 'Untere Farbe')} />
    </label>
  );
}
export function GradientPicker({ c1, c2, enabled, onChange }: { c1: string; c2: string; enabled: boolean; onChange: (c1: string, c2: string, enabled: boolean) => void }) {
  const [, , tr] = useLang();
  return <div className="gp">
    <span className="swatch-column-title">{tr('Profile theme', 'Profil-Schema')}</span>
    <div className="gp-row">
      <div className={'gp-tile' + (enabled ? ' on' : '')} style={{ '--g1': c1, '--g2': c2 } as React.CSSProperties}>
        <Handle pos="top" value={c1} set={v => onChange(v, c2, true)} />
        <Handle pos="bottom" value={c2} set={v => onChange(c1, v, true)} />
      </div>
      <div className="gp-presets">
        <button type="button" className={'gp-preset gp-none' + (!enabled ? ' active' : '')} onClick={() => onChange(c1, c2, false)} title={tr('No theme', 'Kein Schema')}>{tr('Off', 'Aus')}</button>
        {PRESETS.map(([a, b]) => <button type="button" key={a + b} className={'gp-preset' + (enabled && a === c1.toLowerCase() && b === c2.toLowerCase() ? ' active' : '')} style={{ '--g1': a, '--g2': b } as React.CSSProperties} onClick={() => onChange(a, b, true)} aria-label={a + ' → ' + b} />)}
      </div>
    </div>
    <small className="gp-hint">{tr('Tap the dots to pick your own colours.', 'Tippe auf die Punkte, um eigene Farben zu wählen.')}</small>
  </div>;
}
